/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';
import {
  SectorTicketGeneralSettingsContainer,
  States,
} from '@/features/registerEvent/components/SectorTicketGeneralSettingsSreen/screens/ui';
import useForm from '@/hooks/useForm';
import validators from '@/helpers/validators';
import { toast } from 'react-toastify';
import api, { AxiosError } from '@/services/api';
import { FormInputName as FormInputNameToGeneralSettings } from '@/features/registerEvent/components/SectorTicketGeneralSettingsSreen/components/SectorTicketGeneralSettingsContent';
import { useParams } from 'react-router-dom';
import {
  SectorTicketContainerProps,
  TabSectorTicketActionsProps,
} from '@/features/registerEvent/screens/SectorTicket/ui';
import { convertToBoolean } from '@/helpers/common/convertToBoolean';
import { formGeneralSettingsProps, generalSettingsProps } from '../types';

type UrlParams = {
  id: string;
};

export const SectorTicketGeneralSettingsScreen: React.FC<
  Pick<SectorTicketContainerProps, 'ticketStates'> &
    Pick<SectorTicketContainerProps, 'ticketStep'> &
    Omit<TabSectorTicketActionsProps, 'reloadTickets'>
> = ({ ticketStates, ticketStep, backTab }): JSX.Element => {
  const [state] = useState<States>(States.default);

  const params = useParams<UrlParams>();

  const {
    formData: formDataGeneralSettings,
    formErrors: formErrorsGeneralSettings,
    onChangeFormInput: onChangeFormInputGeneralSettings,
    isFormValid: isFormValidGeneralSettings,
    resetForm: resetFormGeneralSettings,
  } = useForm({
    initialData: {
      sendTicketWhatsApp: 'false',
      entranceGate: '',
      nameBeforePurchase: 'false',
      printNameTicket: 'false',
      requestCpf: 'false',
      printCpfTicket: 'false',
      validateCpf: 'false',
      purchaseLimitCpf: '10',
    },
    validators: {
      sendTicketWhatsApp: [validators.required],
      nameBeforePurchase: [validators.required],
      printNameTicket: [validators.required],
      requestCpf: [validators.required],
      printCpfTicket: [validators.required],
      validateCpf: [validators.required],
      purchaseLimitCpf: [validators.required, validators.between(1, 50)],
    },
    formatters: {},
  });

  const handleOnSaveGeneralSettings = async (): Promise<void> => {
    try {
      if (isFormValidGeneralSettings()) {
        const payload = {
          eventTickets: [
            {
              id: ticketStep?.ticketState?.id,
            },
          ],
          sendTicketWhatsApp: convertToBoolean(
            formDataGeneralSettings[FormInputNameToGeneralSettings.sendTicketWhatsApp],
          ),
          entranceGate: formDataGeneralSettings[FormInputNameToGeneralSettings.entranceGate],
          nameBeforePurchase: convertToBoolean(
            formDataGeneralSettings[FormInputNameToGeneralSettings.nameBeforePurchase],
          ),
          printNameTicket: convertToBoolean(
            formDataGeneralSettings[FormInputNameToGeneralSettings.printNameTicket],
          ),
          requestCpf: convertToBoolean(
            formDataGeneralSettings[FormInputNameToGeneralSettings.requestCpf],
          ),
          printCpfTicket: convertToBoolean(
            formDataGeneralSettings[FormInputNameToGeneralSettings.printCpfTicket],
          ),
          validateCpf: convertToBoolean(
            formDataGeneralSettings[FormInputNameToGeneralSettings.validateCpf],
          ),
          purchaseLimitCpf:
            +formDataGeneralSettings[FormInputNameToGeneralSettings.purchaseLimitCpf],
        };

        const response = await api.post(`/event/ticket/${params.id}/general-settings`, payload);
        if (response) {
          ticketStep.setTicketState(undefined as any);
          ticketStates.setTicket(undefined);
        }
        if (response) toast.success('Ingresso adicionado com sucesso!');
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    }
  };

  const handleNextTab = async (): Promise<void> => {
    await handleOnSaveGeneralSettings();
  };

  const handleBackTab = (): void => {
    backTab();
  };

  const controllerFormGeneralSettings: formGeneralSettingsProps = {
    formData: formDataGeneralSettings,
    formErrors: formErrorsGeneralSettings,
    onChangeFormInput: onChangeFormInputGeneralSettings,
    isFormValid: isFormValidGeneralSettings,
  };

  const controllerGeneralSettingsActions: generalSettingsProps = {
    onSave: handleOnSaveGeneralSettings,
    onReturnTab: handleBackTab,
    onNextTab: handleNextTab,
  };

  useEffect(() => {
    const { ticket } = ticketStates;

    resetFormGeneralSettings();

    if (ticket?.generalSettings) {
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.sendTicketWhatsApp)(
        String(ticket.generalSettings.sendTicketWhatsApp),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.entranceGate)(
        String(ticket.generalSettings.entranceGate ?? ''),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.nameBeforePurchase)(
        String(ticket.generalSettings.nameBeforePurchase),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.printNameTicket)(
        String(ticket.generalSettings.printNameTicket),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.requestCpf)(
        String(ticket.generalSettings.requestCpf),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.printCpfTicket)(
        String(ticket.generalSettings.printCpfTicket),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.validateCpf)(
        String(ticket.generalSettings.validateCpf),
      );
      onChangeFormInputGeneralSettings(FormInputNameToGeneralSettings.purchaseLimitCpf)(
        String(ticket.generalSettings.purchaseLimitCpf ?? ''),
      );
    }
  }, [ticketStates.ticket]);

  return (
    <SectorTicketGeneralSettingsContainer
      state={state}
      ticketStates={ticketStates}
      formGeneralSettings={controllerFormGeneralSettings}
      generalSettingsActions={controllerGeneralSettingsActions}
    />
  );
};
